import React from 'react';
import PropTypes from 'prop-types';
import { PlayerProfilePreview } from '../..'
import './StatsTablePlayer.scss';

const StatsTablePlayer = ({ name, playerNumber, avatar, avatarBgColor })=> {
  const firstName = name.split(" ")[0];
  const lastName = name.split(" ")[name.split(" ").length - 1];
  return (
    <div className='stats-table-player'>
      <PlayerProfilePreview
        avatar={avatar}
        firstName={firstName}
        lastName={lastName}
        avatarBgColor={avatarBgColor}
      />
      <span className='stats-table-player__name'>{name}</span>
      <span className='stats-table-player__number'>{playerNumber}</span>
    </div>
  );
};

StatsTablePlayer.propTypes = {
  name: PropTypes.string,
  playerNumber: PropTypes.number
};

StatsTablePlayer.defaultProps = {
  name: '',
  playerNumber: undefined
};

export default StatsTablePlayer;
